import type { CreateHealthActivityResponse } from "@somewear/api";
import type { CreateHealthActivityForm } from "@somewear/model";
import { createActionSet } from "@somewear/model";

export const biometricActions = {
	createHealthActivity: createActionSet<CreateHealthActivityForm, CreateHealthActivityResponse>(
		"biometrics/create"
	),
};
